import Two from 'two.js';

const TwoNoConflict = Two.noConflict();

export default TwoNoConflict;
